import { DataBean } from "../DataBean";

export class ApplyProductionPlan extends DataBean {



    public async applyProductionPlanToProductionOrder(idProductionOrder: any, productionOrderDate: any, idProductionPlan: any, productionPlanDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_applyProductionPlanToProductionOrder_Number_java.util.Date_Number_java.util.Date", [idProductionOrder, productionOrderDate, idProductionPlan, productionPlanDate]);
    }

}